import React from 'react'

interface Props {
  title: string
  children: React.ReactNode
}

export default function Tab(props: Props) {
  return <React.Fragment>{props.children}</React.Fragment>
}
